import Appsignal from '@appsignal/javascript'

const key = ['localhost', '127.0.0.1'].includes(window.location.hostname) ? undefined : 'f73da7fe-8ce4-4e15-804d-0d2b8f9d46bf'
export const appsignal = new Appsignal({ key })
